export enum ResultType {
  HOTEL = 'HOTEL',
  MESSAGING = 'MESSAGING',
  CAROUSEL = 'CAROUSEL',
  LIST_TITLE = 'LIST_TITLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  STATIC_LODGING_MULTI_ITEM_CROSS_SELL = 'STATIC_LODGING_MULTI_ITEM_CROSS_SELL'
}
